import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url;  // obtengo la url de donde estoy
    const redirectUrl = this.getRedirectUrl(currentUrl);

    // una verificacion para evitar loops infinitos
    if (redirectUrl && currentUrl !== redirectUrl) {
      this.router.navigate([redirectUrl]);
      return false;  // regreso false para evaluar que no se active la ruta pues estoy donde mismo
    }

    return true;  // regreso true para evaluar que se active la ruta
  }

  private getRedirectUrl(currentUrl: string): string | null {
    // para redireccionar dependiendo de la variable de ambiente
    switch (environment.CLIENTE.toLowerCase()) {
      //ambientes trinitas
      case 'GLOBAL'.toLowerCase():
        if (currentUrl === '/home') {
          return '/logingfc';
        }
        return '/logingfc';
      case 'LEASING'.toLowerCase():
        if (currentUrl === '/home') {
          return '/home';
        }
        return '/login';
      default:
        return null;  // no redirigir a ningun lado y puedo entrar a todo
    }
  }
}